import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "@madmedical/i18n";
import useResponsive from "../../util/useResponsive";
import ListHeader from "../../molecules/ListHeader";
const Charts = ({ charts }) => {
    const { isSmallScreen } = useResponsive();
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [isSmallScreen && (_jsx(ListHeader, { title: t("measures:title"), borderBottomWidth: 0, px: 0 })), charts] }));
};
export default Charts;
